// Testnet & Dev mode

module.exports = {
  loginurl: 'Dashboard',
  baseurl: '/',
  tutorial: '/tutorial',
  myprofile: '/profile',
  Exchange: '/exch/',
  LaunchApp: '/app/',
  s3BaseUrl: 'https://infiuserprofile.s3.eu-west-2.amazonaws.com/',
  ApiURL: 'https://infimultichain.com/api/',
  //ApiURL: 'http://localhost:9090/api/',
};
//};

//++++++++++++++++++++++Mainnet client server+++++++++++++++++++++

// module.exports = {
//   loginurl: 'Dashboard',
//   baseurl: '/',
//   tutorial: '/tutorial',
//   myprofile: '/profile',
//   Exchange: '/exch/',
//   LaunchApp: '/app/',
//   s3BaseUrl: 'https://infiuserprofile.s3.eu-west-2.amazonaws.com/',
//   ApiURL: 'https://infimultichain.com/api/',
// };
